import siteConfig from './siteConfig/siteConfigSlice';

const root = {
	siteConfig
};

export default root;
